var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "12px",
    viewBox: "0 0 16 15",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "download") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "General/CTA/Download",
    transform: "translate(-105.000000, -2.000000)",
    fill: "#102B4E"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/download/Dark-Blue-1",
    transform: "translate(105.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "download"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5152542,7.31636156 C15.2610169,7.31636156 15.0576271,7.52231121 15.0576271,7.77974828 L15.0576271,11.9948513 C15.0576271,13.1413043 14.1355932,14.0715103 13.0067797,14.0715103 L2.96610169,14.0715103 C1.83389831,14.0715103 0.915254237,13.1378719 0.915254237,11.9948513 L0.915254237,7.7110984 C0.915254237,7.45366133 0.711864407,7.24771167 0.457627119,7.24771167 C0.203389831,7.24771167 0,7.45366133 0,7.7110984 L0,11.9948513 C0,13.652746 1.33220339,14.9982838 2.96610169,14.9982838 L13.0067797,14.9982838 C14.6440678,14.9982838 15.9728814,13.6493135 15.9728814,11.9948513 L15.9728814,7.77974828 C15.9728814,7.52574371 15.7694915,7.31636156 15.5152542,7.31636156 Z",
    id: "Path",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.66440678,11.3186499 C7.75254237,11.4078947 7.87118644,11.4559497 7.98644068,11.4559497 C8.10169492,11.4559497 8.22033898,11.4113272 8.30847458,11.3186499 L11.2169492,8.37356979 C11.3966102,8.1916476 11.3966102,7.89988558 11.2169492,7.71796339 C11.0372881,7.53604119 10.7491525,7.53604119 10.5694915,7.71796339 L8.4440678,9.87356979 L8.4440678,0.471967963 C8.4440678,0.214530892 8.24067797,0.0085812357 7.98644068,0.0085812357 C7.73220339,0.0085812357 7.52881356,0.214530892 7.52881356,0.471967963 L7.52881356,9.87356979 L5.4,7.71796339 C5.22033898,7.53604119 4.93220339,7.53604119 4.75254237,7.71796339 C4.57288136,7.89988558 4.57288136,8.1916476 4.75254237,8.37356979 L7.66440678,11.3186499 Z",
    id: "Path",
    fillRule: "nonzero"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.4de051824f4240e5610192b129eba946.svg";
export { ForwardRef as ReactComponent };